export { ResultCardCarousel } from './ResultCardCarousel';
